import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgChevronUp = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M10.807 9.79a.62.62 0 0 1-.931 0L8 7.737 6.124 9.79a.62.62 0 0 1-.931 0 .77.77 0 0 1 0-1.018l2.341-2.56a.62.62 0 0 1 .932 0l2.341 2.56a.77.77 0 0 1 0 1.018"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
